<div class="summary-container" *ngIf="dataSource && displayedColumns">
  <div class="align-right">
    <mat-slide-toggle color="primary" [checked]="showEmptyValues" labelPosition="after" (change)="loadSummaryMappings($event)">
      Show empty values
    </mat-slide-toggle>
  </div>
  <h2>
    {{classifierType}} Mappings by Country
  </h2>
  <div align="end" class="download-button-container">
    <button mat-button color="primary" (click)="downloadExcel()">
      <mat-icon>description</mat-icon>
      <span>Export to excel</span>
    </button>
  </div>

  <div class="table-container" *ngIf="dataSource && dataSource.length">
    <table mat-table [dataSource]="dataSource" matSort>

      <!--  Category/Collection stream  -->
      <ng-container matColumnDef="classifier" sticky>
        <th mat-header-cell *matHeaderCellDef>{{classifierType}}</th>
        <td mat-cell *matCellDef="let item; let i = index"
            [attr.rowspan]="item.classifierRowSpan"
            [style.display]="item.classifierRowSpan ? '' : 'none'">
          {{item.classifier}}
        </td>
      </ng-container>

      <!-- Unu-Key -->
      <ng-container matColumnDef="unuKey" sticky>
        <th mat-header-cell *matHeaderCellDef> Unu-Key</th>
        <td mat-cell *matCellDef="let item; let i = index" [ngClass]="i % 2 ? 'pair' : 'odd'">
          {{item.unuKey}}
        </td>
      </ng-container>

      <!--  Country columns  -->
      <ng-container *ngFor="let countryColumn of displayedColumns  | slice: 2: displayedColumns.length - 1"
                    matColumnDef="{{countryColumn}}">
        <th mat-header-cell *matHeaderCellDef>{{countryColumn}}</th>
        <td mat-cell *matCellDef="let item; let i = index" [ngClass]="i % 2 ? 'pair' : 'odd'" class="country-cell">
          <mat-icon color="primary" *ngIf="item[getCountryCodeFromHeader(countryColumn)]">circle</mat-icon>
        </td>
      </ng-container>

      <!--  Total mappings  -->
      <ng-container matColumnDef="total" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Total matches</th>
        <td mat-cell *matCellDef="let item; let i = index" [ngClass]="i % 2 ? 'pair' : 'odd'"> {{item.total}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>


  </div>

</div>
